import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      nav: {
        home: "Accueil",
        gallery: "Galerie",
        boutique: "Boutique",
        orders: "Commandes & Livraisons",
        contact: "Horaires & Contact",
        emploi: "Emploi"
      },
      home: {
        hero_tagline: "BOUTIQUE · FLEURS · DÉCORATION · ÉVÉNEMENTS",
        hero_cta: "Commander en ligne",
        hero_secondary: "Notre galerie",
        citation: "Par amour, une fleur donne sa beauté pour égayer son entourage...",
        welcome_title: "Bienvenue !",
        welcome_subtitle: "Votre artisan fleuriste à Martigny, Verbier et Sion",
        welcome_text: "Plongez dans l'univers poétique et raffiné des Noces de Ginkgo, où chaque bouquet raconte une histoire, et chaque création florale est un véritable hommage à la nature.",
        welcome_text2: "Inspirée par l'élégance intemporelle du ginkgo, symbole de longévité et de résilience, notre équipe imagine pour vous des compositions uniques, mêlant tradition et modernité.",
        boutiques_title: "Les Boutiques",
        boutiques_subtitle: "Retrouvez-nous dans nos différentes boutiques en Valais",
        boutiques_cta: "Adresses & Horaires",
        order_online: "Commander en ligne",
        order_phone: "Par téléphone",
        reviews_title: "Ce que nos clients disent",
        reviews_count: "194 avis · 4,9 étoiles",
        discover: "Découvrir",
        new_sion: "Nous ouvrons à Sion !",
        alma_story: "Alma fleurs devient Les Noces de Ginkgo. C'est avec une immense joie que nous vous annonçons la reprise de la boutique Alma Fleurs au cœur de Sion. Après 35 années de passion, Nicolas nous transmet le flambeau.",
      },
      gallery: {
        title: "Galerie",
        subtitle: "Un espace dédié à la beauté florale et à l'inspiration",
        description: "Découvrez à travers nos photos un aperçu de notre univers, où chaque bouquet, chaque arrangement raconte une histoire unique.",
        all: "Tout voir",
        tous: "Tous",
        weddings: "Mariages",
        mariages: "Mariages",
        shooting: "Shooting",
        reception: "Réception",
        photo_credit: "Photo",
      },
      boutique: {
        title: "Nos Boutiques",
        subtitle: "Trois lieux, une même passion",
        description: "Aux Noces de Ginkgo, nous avons à cœur de vous offrir des compositions florales uniques, créatives et de qualité, adaptées à toutes les occasions.",
        martigny_title: "Martigny",
        martigny_text: "Située au cœur de Martigny, notre première boutique, vieille de plus de 70 ans, est un véritable havre de paix pour les amoureux des fleurs. Vous y découvrirez un espace chaleureux, où l'on se fait un plaisir de vous guider dans le choix de vos fleurs, selon vos envies et vos besoins.",
        verbier_title: "Verbier",
        verbier_text: "Notre seconde boutique, ouverte en août 2021 à Verbier, vit au rythme des saisons. Des décorations de Noël aux bouquets estivaux, nous proposons des créations sur mesure selon les envies de notre clientèle.",
        sion_title: "Sion",
        sion_text: "Au cœur de Sion, notre boutique reprend vie en janvier 2026, dans la continuité de la belle histoire d'Alma Fleurs. Pendant 35 ans, Nicolas a fait de ce lieu un incontournable, animé par la passion des fleurs.",
        visit: "Voir les horaires",
        order: "Commander",
      },
      orders: {
        title: "Commander en ligne",
        subtitle: "Remplissez notre formulaire — nous confirmerons votre commande dans les meilleurs délais",
        required: "* Champ obligatoire",
        section_order: "Votre commande",
        boutique_label: "Boutique *",
        boutique_placeholder: "Choisissez votre boutique",
        boutique_martigny: "Boutique Martigny — Rue des Petits-Epineys 3",
        boutique_verbier: "Boutique Verbier — Rte des Creux 6",
        boutique_sion: "Boutique Sion — Av. du Ritz 33",
        description_label: "Description de la commande *",
        description_placeholder: "- fleurs souhaitées\n- couleurs / tons\n- arrangement, bouquet, plante...\n- avec/sans verdure",
        budget_label: "Montant souhaité en CHF (hors livraison et carte) *",
        budget_placeholder: "Ex: 50.-",
        section_card: "Carte de vœux",
        card_label: "Souhaitez-vous ajouter une carte ? *",
        card_none: "Pas de carte, merci",
        card_small: "Petite carte blanche 10×8cm — max 120 caractères (2.-)",
        card_a6: "Carte A6 en boutique (entre 6 et 8.-)",
        card_text_label: "Texte à écrire sur la carte *",
        card_text_placeholder: "Votre message...",
        section_delivery: "Livraison",
        delivery_label: "Souhaitez-vous une livraison ? *",
        delivery_yes: "Oui, livrer",
        delivery_no: "Non",
        delivery_pickup: "A retirer en boutique",
        delivery_date_label: "Date souhaitée (JJ.MM.AAAA) *",
        delivery_date_placeholder: "Ex: 15.03.2025",
        delivery_note: "La date sera confirmée en même temps que la commande",
        delivery_sion_note: "Livraison à Sion : 10.-",
        delivery_pricing: "Voir le tarif de livraison",
        section_recipient: "Destinataire",
        recipient_name: "Nom du destinataire *",
        recipient_firstname: "Prénom du destinataire *",
        sender_phone: "Votre numéro de téléphone *",
        recipient_phone: "Téléphone du destinataire *",
        recipient_phone_note: "Nous contactons la personne avant la livraison",
        delivery_address: "Adresse de livraison *",
        section_payment: "Paiement",
        payment_label: "Mode de paiement *",
        payment_email: "Facture par email",
        payment_postal: "Facture voie postale (+ 2.-)",
        payment_card: "Paiement par carte (appelez la boutique)",
        email_label: "Email *",
        email_placeholder: "votre@email.ch",
        billing_address_label: "Adresse de facturation *",
        submit: "Valider la commande",
        submitting: "Envoi en cours...",
        success_title: "Commande reçue avec succès !",
        success_text: "Nous vous remercions pour votre commande. Elle sera confirmée dans les meilleurs délais. N'hésitez pas à nous appeler en boutique si la commande est pour aujourd'hui !",
        new_order: "Passer une nouvelle commande",
        call_note: "Pour une commande urgente du jour, appelez directement en boutique.",
      },
      contact: {
        title: "Horaires & Contact",
        subtitle: "Retrouvez-nous dans nos boutiques en Valais",
        hours: "Horaires d'ouverture",
        address: "Adresse",
        phone: "Téléphone",
        email: "Email",
        mon_fri: "Lundi – Vendredi",
        saturday: "Samedi",
        sunday: "Dimanche",
        closed: "Fermé",
        winter_season: "Saison hivernale 25/26",
        non_stop: "Non-stop",
        get_directions: "Itinéraire",
        martigny_hours_weekday: "09h00 – 12h00 / 13h30 – 18h30",
        martigny_hours_sat: "09h00 – 12h00 / 13h00 – 17h00",
        martigny_hours_sun: "09h00 – 12h00",
        verbier_hours: "10h00 – 18h30 (non-stop)",
        verbier_hours_sun: "Fermé",
        sion_hours_weekday: "09h00 – 12h00 / 13h30 – 18h30",
        sion_hours_sat: "09h00 – 12h00 / 13h00 – 17h00",
        sion_hours_sun: "Fermé",
      },
      emploi: {
        title: "Emploi",
        subtitle: "Rejoindre notre équipe",
        intro: "L'équipe est actuellement au complet, mais nous sommes toujours à la recherche de talents ! Alors n'hésitez pas à nous envoyer votre candidature spontanée si l'envie de travailler avec nous se fait sentir.",
        form_title: "Candidature spontanée",
        name_label: "Nom complet *",
        name_placeholder: "Prénom Nom",
        email_label: "Email *",
        email_placeholder: "votre@email.ch",
        phone_label: "Téléphone",
        phone_placeholder: "+41 xx xxx xx xx",
        message_label: "Message / Lettre de motivation *",
        message_placeholder: "Parlez-nous de vous, de vos expériences et de votre motivation...",
        submit: "Envoyer ma candidature",
        submitting: "Envoi en cours...",
        success_title: "Candidature envoyée !",
        success_text: "Merci pour votre candidature. Nous reviendrons vers vous rapidement. À bientôt !",
        contact_direct: "Ou envoyez directement un email à",
      },
      footer: {
        tagline: "Artisan fleuriste depuis 1954 · Martigny, Verbier & Sion",
        nav_title: "Navigation",
        contact_title: "Contact",
        rights: "Tous droits réservés",
        made_in: "Artisan fleuriste en Valais, Suisse",
      }
    }
  },
  en: {
    translation: {
      nav: {
        home: "Home",
        gallery: "Gallery",
        boutique: "Boutique",
        orders: "Orders & Delivery",
        contact: "Hours & Contact",
        emploi: "Employment"
      },
      home: {
        hero_tagline: "BOUTIQUE · FLOWERS · DECORATION · EVENTS",
        hero_cta: "Order online",
        hero_secondary: "Our gallery",
        citation: "Out of love, a flower gives its beauty to brighten its surroundings...",
        welcome_title: "Welcome!",
        welcome_subtitle: "Your craft florist in Martigny, Verbier and Sion",
        welcome_text: "Immerse yourself in the poetic and refined world of Les Noces de Ginkgo, where every bouquet tells a story and every floral creation is a true tribute to nature.",
        welcome_text2: "Inspired by the timeless elegance of the ginkgo — symbol of longevity and resilience — our team crafts unique compositions blending tradition and modernity.",
        boutiques_title: "Our Boutiques",
        boutiques_subtitle: "Find us in our different shops across Valais",
        boutiques_cta: "Addresses & Hours",
        order_online: "Order online",
        order_phone: "By phone",
        reviews_title: "What our clients say",
        reviews_count: "194 reviews · 4.9 stars",
        discover: "Discover",
        new_sion: "Opening in Sion!",
        alma_story: "Alma Fleurs becomes Les Noces de Ginkgo. We are thrilled to announce the takeover of Alma Fleurs in the heart of Sion. After 35 years of passion, Nicolas passes us the torch.",
      },
      gallery: {
        title: "Gallery",
        subtitle: "A space dedicated to floral beauty and inspiration",
        description: "Discover through our photos a glimpse of our world, where every bouquet and arrangement tells a unique story.",
        all: "View all",
        tous: "All",
        weddings: "Weddings",
        mariages: "Weddings",
        shooting: "Photo Shoots",
        reception: "Receptions",
        photo_credit: "Photo",
      },
      boutique: {
        title: "Our Boutiques",
        subtitle: "Three locations, one passion",
        description: "At Les Noces de Ginkgo, we strive to offer unique, creative and quality floral compositions for every occasion.",
        martigny_title: "Martigny",
        martigny_text: "Located in the heart of Martigny, our first boutique — over 70 years old — is a true haven for flower lovers. You will discover a warm space where we guide you in choosing your flowers according to your wishes.",
        verbier_title: "Verbier",
        verbier_text: "Our second boutique, opened in August 2021 in Verbier, lives to the rhythm of the seasons. From Christmas decorations to summer bouquets, we offer bespoke creations tailored to our clients.",
        sion_title: "Sion",
        sion_text: "In the heart of Sion, our boutique reopened in January 2026, continuing the beautiful story of Alma Fleurs. For 35 years, Nicolas made this place iconic, driven by passion for flowers.",
        visit: "See hours",
        order: "Order",
      },
      orders: {
        title: "Order online",
        subtitle: "Fill out our form — we'll confirm your order as soon as possible",
        required: "* Required field",
        section_order: "Your order",
        boutique_label: "Boutique *",
        boutique_placeholder: "Choose your boutique",
        boutique_martigny: "Martigny Boutique — Rue des Petits-Epineys 3",
        boutique_verbier: "Verbier Boutique — Rte des Creux 6",
        boutique_sion: "Sion Boutique — Av. du Ritz 33",
        description_label: "Order description *",
        description_placeholder: "- desired flowers\n- colours / tones\n- arrangement, bouquet, plant...\n- with/without greenery",
        budget_label: "Budget in CHF (excl. delivery and card) *",
        budget_placeholder: "E.g. 50.-",
        section_card: "Greeting card",
        card_label: "Would you like to add a card? *",
        card_none: "No card, thank you",
        card_small: "Small white card 10×8cm — max 120 chars (2.-)",
        card_a6: "A6 card in boutique (between 6 and 8.-)",
        card_text_label: "Text to write on the card *",
        card_text_placeholder: "Your message...",
        section_delivery: "Delivery",
        delivery_label: "Do you need delivery? *",
        delivery_yes: "Yes, deliver",
        delivery_no: "No",
        delivery_pickup: "I'll pick up in store",
        delivery_date_label: "Desired date (DD.MM.YYYY) *",
        delivery_date_placeholder: "E.g. 15.03.2025",
        delivery_note: "The date will be confirmed along with the order",
        delivery_sion_note: "Delivery in Sion: 10.-",
        delivery_pricing: "View delivery rates",
        section_recipient: "Recipient",
        recipient_name: "Recipient's last name *",
        recipient_firstname: "Recipient's first name *",
        sender_phone: "Your phone number *",
        recipient_phone: "Recipient's phone number *",
        recipient_phone_note: "We contact them before delivery",
        delivery_address: "Delivery address *",
        section_payment: "Payment",
        payment_label: "Payment method *",
        payment_email: "Invoice by email",
        payment_postal: "Postal invoice (+ 2.-)",
        payment_card: "Card payment (call the boutique)",
        email_label: "Email *",
        email_placeholder: "your@email.ch",
        billing_address_label: "Billing address *",
        submit: "Submit order",
        submitting: "Sending...",
        success_title: "Order received!",
        success_text: "Thank you for your order. It will be confirmed as soon as possible. Don't hesitate to call if your order is for today!",
        new_order: "Place a new order",
        call_note: "For same-day orders, please call the boutique directly.",
      },
      contact: {
        title: "Hours & Contact",
        subtitle: "Find us in our boutiques across Valais",
        hours: "Opening hours",
        address: "Address",
        phone: "Phone",
        email: "Email",
        mon_fri: "Monday – Friday",
        saturday: "Saturday",
        sunday: "Sunday",
        closed: "Closed",
        winter_season: "Winter season 25/26",
        non_stop: "Non-stop",
        get_directions: "Get directions",
        martigny_hours_weekday: "09:00 – 12:00 / 13:30 – 18:30",
        martigny_hours_sat: "09:00 – 12:00 / 13:00 – 17:00",
        martigny_hours_sun: "09:00 – 12:00",
        verbier_hours: "10:00 – 18:30 (non-stop)",
        verbier_hours_sun: "Closed",
        sion_hours_weekday: "09:00 – 12:00 / 13:30 – 18:30",
        sion_hours_sat: "09:00 – 12:00 / 13:00 – 17:00",
        sion_hours_sun: "Closed",
      },
      emploi: {
        title: "Employment",
        subtitle: "Join our team",
        intro: "Our team is currently complete, but we are always looking for talent! Feel free to send us a spontaneous application if you'd like to work with us.",
        form_title: "Spontaneous application",
        name_label: "Full name *",
        name_placeholder: "First Last",
        email_label: "Email *",
        email_placeholder: "your@email.ch",
        phone_label: "Phone",
        phone_placeholder: "+41 xx xxx xx xx",
        message_label: "Message / Cover letter *",
        message_placeholder: "Tell us about yourself, your experience and your motivation...",
        submit: "Send my application",
        submitting: "Sending...",
        success_title: "Application sent!",
        success_text: "Thank you for your application. We will get back to you soon. See you soon!",
        contact_direct: "Or send an email directly to",
      },
      footer: {
        tagline: "Craft florist since 1954 · Martigny, Verbier & Sion",
        nav_title: "Navigation",
        contact_title: "Contact",
        rights: "All rights reserved",
        made_in: "Craft florist in Valais, Switzerland",
      }
    }
  },
  de: {
    translation: {
      nav: {
        home: "Startseite",
        gallery: "Galerie",
        boutique: "Boutique",
        orders: "Bestellungen & Lieferung",
        contact: "Öffnungszeiten & Kontakt",
        emploi: "Stellenangebote"
      },
      home: {
        hero_tagline: "BOUTIQUE · BLUMEN · DEKORATION · EVENTS",
        hero_cta: "Online bestellen",
        hero_secondary: "Unsere Galerie",
        citation: "Aus Liebe gibt eine Blume ihre Schönheit, um ihre Umgebung zu erheitern...",
        welcome_title: "Willkommen!",
        welcome_subtitle: "Ihr Kunsthandwerker-Florist in Martigny, Verbier und Sion",
        welcome_text: "Tauchen Sie ein in die poetische und raffinierte Welt von Les Noces de Ginkgo, wo jeder Strauss eine Geschichte erzählt und jede Blumenkomposition eine Hommage an die Natur ist.",
        welcome_text2: "Inspiriert von der zeitlosen Eleganz des Ginkgo — Symbol für Langlebigkeit und Resilienz — kreiert unser Team einzigartige Kompositionen, die Tradition und Moderne verbinden.",
        boutiques_title: "Unsere Boutiquen",
        boutiques_subtitle: "Besuchen Sie uns in unseren Boutiquen im Wallis",
        boutiques_cta: "Adressen & Öffnungszeiten",
        order_online: "Online bestellen",
        order_phone: "Telefonisch",
        reviews_title: "Was unsere Kunden sagen",
        reviews_count: "194 Bewertungen · 4,9 Sterne",
        discover: "Entdecken",
        new_sion: "Wir eröffnen in Sion!",
        alma_story: "Alma Fleurs wird zu Les Noces de Ginkgo. Mit grosser Freude kündigen wir die Übernahme von Alma Fleurs in Sion an. Nach 35 Jahren Leidenschaft gibt Nicolas die Fackel weiter.",
      },
      gallery: {
        title: "Galerie",
        subtitle: "Ein Raum für Blumenschönheit und Inspiration",
        description: "Entdecken Sie durch unsere Fotos einen Einblick in unsere Welt, wo jeder Strauss und jede Komposition eine einzigartige Geschichte erzählt.",
        all: "Alle anzeigen",
        tous: "Alle",
        weddings: "Hochzeiten",
        mariages: "Hochzeiten",
        shooting: "Fotoshooting",
        reception: "Empfänge",
        photo_credit: "Foto",
      },
      boutique: {
        title: "Unsere Boutiquen",
        subtitle: "Drei Standorte, eine Leidenschaft",
        description: "Bei Les Noces de Ginkgo bieten wir einzigartige, kreative und qualitativ hochwertige Blumenkompositionen für jeden Anlass.",
        martigny_title: "Martigny",
        martigny_text: "Im Herzen von Martigny gelegen, ist unsere erste Boutique — über 70 Jahre alt — eine wahre Oase für Blumenliebhaber. Sie finden einen warmen Raum, in dem wir Sie gerne bei der Wahl Ihrer Blumen beraten.",
        verbier_title: "Verbier",
        verbier_text: "Unsere zweite Boutique, 2021 in Verbier eröffnet, lebt im Rhythmus der Jahreszeiten. Von Weihnachtsdekorationen bis zu Sommerstraussen bieten wir massgeschneiderte Kreationen.",
        sion_title: "Sion",
        sion_text: "Im Herzen von Sion hat unsere Boutique im Januar 2026 wieder geöffnet, in der Tradition von Alma Fleurs. 35 Jahre lang hat Nicolas diesen Ort zum Inbegriff seiner Leidenschaft gemacht.",
        visit: "Öffnungszeiten",
        order: "Bestellen",
      },
      orders: {
        title: "Online bestellen",
        subtitle: "Füllen Sie unser Formular aus — wir bestätigen Ihre Bestellung so schnell wie möglich",
        required: "* Pflichtfeld",
        section_order: "Ihre Bestellung",
        boutique_label: "Boutique *",
        boutique_placeholder: "Wählen Sie Ihre Boutique",
        boutique_martigny: "Boutique Martigny — Rue des Petits-Epineys 3",
        boutique_verbier: "Boutique Verbier — Rte des Creux 6",
        boutique_sion: "Boutique Sion — Av. du Ritz 33",
        description_label: "Bestellbeschreibung *",
        description_placeholder: "- gewünschte Blumen\n- Farben / Töne\n- Arrangement, Strauss, Pflanze...\n- mit/ohne Grünzeug",
        budget_label: "Budget in CHF (ohne Lieferung und Karte) *",
        budget_placeholder: "Z.B. 50.-",
        section_card: "Grüsskarte",
        card_label: "Möchten Sie eine Grüsskarte hinzufügen? *",
        card_none: "Keine Karte, danke",
        card_small: "Kleine weisse Karte 10×8cm — max. 120 Zeichen (2.-)",
        card_a6: "A6-Karte in der Boutique (zwischen 6 und 8.-)",
        card_text_label: "Text für die Karte *",
        card_text_placeholder: "Ihre Nachricht...",
        section_delivery: "Lieferung",
        delivery_label: "Benötigen Sie eine Lieferung? *",
        delivery_yes: "Ja, liefern",
        delivery_no: "Nein",
        delivery_pickup: "Ich hole selbst ab",
        delivery_date_label: "Gewünschtes Datum (TT.MM.JJJJ) *",
        delivery_date_placeholder: "Z.B. 15.03.2025",
        delivery_note: "Das Datum wird zusammen mit der Bestellung bestätigt",
        delivery_sion_note: "Lieferung in Sion: 10.-",
        delivery_pricing: "Liefertarif ansehen",
        section_recipient: "Empfänger",
        recipient_name: "Nachname des Empfängers *",
        recipient_firstname: "Vorname des Empfängers *",
        sender_phone: "Ihre Telefonnummer *",
        recipient_phone: "Telefon des Empfängers *",
        recipient_phone_note: "Wir kontaktieren die Person vor der Lieferung",
        delivery_address: "Lieferadresse *",
        section_payment: "Zahlung",
        payment_label: "Zahlungsart *",
        payment_email: "Rechnung per Email",
        payment_postal: "Rechnung per Post (+ 2.-)",
        payment_card: "Kartenzahlung (Boutique anrufen)",
        email_label: "Email *",
        email_placeholder: "ihre@email.ch",
        billing_address_label: "Rechnungsadresse *",
        submit: "Bestellung aufgeben",
        submitting: "Wird gesendet...",
        success_title: "Bestellung erhalten!",
        success_text: "Vielen Dank für Ihre Bestellung. Sie wird so schnell wie möglich bestätigt. Rufen Sie uns an, wenn Ihre Bestellung für heute ist!",
        new_order: "Neue Bestellung aufgeben",
        call_note: "Für dringende Tagesbestellungen rufen Sie bitte direkt die Boutique an.",
      },
      contact: {
        title: "Öffnungszeiten & Kontakt",
        subtitle: "Besuchen Sie uns in unseren Boutiquen im Wallis",
        hours: "Öffnungszeiten",
        address: "Adresse",
        phone: "Telefon",
        email: "Email",
        mon_fri: "Montag – Freitag",
        saturday: "Samstag",
        sunday: "Sonntag",
        closed: "Geschlossen",
        winter_season: "Wintersaison 25/26",
        non_stop: "Durchgehend",
        get_directions: "Route planen",
        martigny_hours_weekday: "09:00 – 12:00 / 13:30 – 18:30",
        martigny_hours_sat: "09:00 – 12:00 / 13:00 – 17:00",
        martigny_hours_sun: "09:00 – 12:00",
        verbier_hours: "10:00 – 18:30 (durchgehend)",
        verbier_hours_sun: "Geschlossen",
        sion_hours_weekday: "09:00 – 12:00 / 13:30 – 18:30",
        sion_hours_sat: "09:00 – 12:00 / 13:00 – 17:00",
        sion_hours_sun: "Geschlossen",
      },
      emploi: {
        title: "Stellenangebote",
        subtitle: "Unser Team verstärken",
        intro: "Unser Team ist derzeit vollständig besetzt, aber wir suchen immer nach Talenten! Zögern Sie nicht, uns Ihre Initiativbewerbung zu schicken.",
        form_title: "Initiativbewerbung",
        name_label: "Vollständiger Name *",
        name_placeholder: "Vorname Nachname",
        email_label: "Email *",
        email_placeholder: "ihre@email.ch",
        phone_label: "Telefon",
        phone_placeholder: "+41 xx xxx xx xx",
        message_label: "Nachricht / Motivationsschreiben *",
        message_placeholder: "Erzählen Sie uns von sich, Ihrer Erfahrung und Ihrer Motivation...",
        submit: "Bewerbung senden",
        submitting: "Wird gesendet...",
        success_title: "Bewerbung gesendet!",
        success_text: "Vielen Dank für Ihre Bewerbung. Wir werden uns bald bei Ihnen melden. Bis bald!",
        contact_direct: "Oder senden Sie direkt eine Email an",
      },
      footer: {
        tagline: "Kunsthandwerker-Florist seit 1954 · Martigny, Verbier & Sion",
        nav_title: "Navigation",
        contact_title: "Kontakt",
        rights: "Alle Rechte vorbehalten",
        made_in: "Kunsthandwerker-Florist im Wallis, Schweiz",
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('ginkgo_lang') || 'fr',
    fallbackLng: 'fr',
    interpolation: { escapeValue: false }
  });

export default i18n;
